import { render, staticRenderFns } from "./tabs-bar.vue?vue&type=template&id=b9112e48&scoped=true&"
import script from "./tabs-bar.vue?vue&type=script&lang=js&"
export * from "./tabs-bar.vue?vue&type=script&lang=js&"
import style0 from "./tabs-bar.vue?vue&type=style&index=0&id=b9112e48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9112e48",
  null
  
)

export default component.exports